console.log("assets/theme.js loaded...");
const LANG_KEY = 'skilltrack_lang';

function getCurrentLanguage() {
    return getFromLocalStorageForEnvRaw(LANG_KEY) || 'da';
}

console.log("Current language setting:", Shopify.locale);
// Store the current language in localStorage for later use

const currentLang = getCurrentLanguage();
console.log("Previously stored language is:", currentLang);
if(currentLang) {
    console.log("Using previously stored language:", currentLang);
    Shopify.locale = currentLang;
}

if (Shopify && Shopify.locale) {
    setLocalStorageForEnvRaw(LANG_KEY, Shopify.locale);
}

if (Shopify.designMode) document.documentElement.classList.add('shopify-design-mode');

document.addEventListener("DOMContentLoaded", () => {
const progressElement = document.getElementById("progress");
if (!progressElement) return;
let progress = 0;
const iv = setInterval(() => {
    progress = Math.min(progress + 10, 100);
    progressElement.style.width = progress + "%";
    if (progress === 100) clearInterval(iv);
}, 500);
});

document.addEventListener("DOMContentLoaded", () => {
const button = document.getElementById('generateButton');
const loadingPopup = document.getElementById('loadingPopup');
if (!button || !loadingPopup) return;
button.addEventListener('click', () => {
    loadingPopup.classList.add('active');
    setTimeout(() => loadingPopup.classList.remove('active'), 12000);
});
});

// `primary`, `fallback`, and `locale` are defined in `layout/theme.liquid`
window.SK = window.SK || {};

SK.locale  = locale;
SK.locales = SK.locales || {};
// const primary = `/locales/${SK.locale}.json`;
// const fallback = `/locales/en.json`;

SK.tMsg = (path, fallbackText="", vars = {}) => {
    console.log("SK.tMsg called with:", { path, fallbackText, vars });
    if (typeof path !== "string") {
        console.error("[SK i18n] tMsg: expected string path, got " + typeof path);
        return String(path);
    }

    const dict = SK.locales[SK.locale] || {};
    let val = path.split(".").reduce((o, k) => (o && o[k] != null ? o[k] : undefined), dict);

    if (typeof val !== "string") return fallbackText ?? path;

    return val.replace(/\{(\w+)\}/g, (match, key) =>
        vars[key] != null ? vars[key] : match
    );
};

/** 
 * this is an async IIFE (Immediately Invoked Function Expression) that executes immediately when the script is parsed.
 * It loads the locale data for the current language.
 * If loading fails, it falls back to English.
 * we can wait on it with `await SK.i18nReady` to be sure translations are loaded (it waits only until the first resolution; after that it is effectively a no-op.)
 */
SK.i18nReady = (async () => {
    async function load(url) {
        const r = await fetch(url, { credentials: "omit" });
        if (!r.ok) throw new Error(r.status);
        return r.json();
    }

    try {
        SK.locales[locale] = await load(primary);
    } catch (e) {
        console.warn("[SK i18n] fallback to EN", e);
        SK.locales[locale] = await load(fallback);
    }

    return true;
})();


window.shopUrl = '{{ request.origin }}';
window.routes = {
cart_add_url: '{{ routes.cart_add_url }}',
cart_change_url: '{{ routes.cart_change_url }}',
cart_update_url: '{{ routes.cart_update_url }}',
cart_url:       '{{ routes.cart_url }}',
predictive_search_url: '{{ routes.predictive_search_url }}',
};

window.cartStrings = {
error: `{{ 'sections.cart.cart_error' | t }}`,
quantityError: `{{ 'sections.cart.cart_quantity_error_html' | t: quantity: '[quantity]' }}`,
};

window.variantStrings = {
addToCart:  `{{ 'products.product.add_to_cart' | t }}`,
soldOut:    `{{ 'products.product.sold_out' | t }}`,
unavailable:`{{ 'products.product.unavailable' | t }}`,
unavailable_with_option: `{{ 'products.product.value_unavailable' | t: option_value: '[value]' }}`,
};

window.quickOrderListStrings = {
itemsAdded:  `{{ 'sections.quick_order_list.items_added.other' | t: quantity: '[quantity]' }}`,
itemAdded:   `{{ 'sections.quick_order_list.items_added.one'  | t: quantity: '[quantity]' }}`,
itemsRemoved:`{{ 'sections.quick_order_list.items_removed.other' | t: quantity: '[quantity]' }}`,
itemRemoved: `{{ 'sections.quick_order_list.items_removed.one'   | t: quantity: '[quantity]' }}`,
viewCart:    `{{- 'sections.quick_order_list.view_cart' | t -}}`,
each:        `{{- 'sections.quick_order_list.each' | t: money: '[money]' }}`,
min_error:   `{{- 'sections.quick_order_list.min_error' | t: min: '[min]' }}`,
max_error:   `{{- 'sections.quick_order_list.max_error' | t: max: '[max]' }}`,
step_error:  `{{- 'sections.quick_order_list.step_error' | t: step: '[step]' }}`,
};

window.accessibilityStrings = {
imageAvailable: `{{ 'products.product.media.image_available' | t: index: '[index]' }}`,
shareSuccess:   `{{ 'general.share.success_message' | t }}`,
pauseSlideshow: `{{ 'sections.slideshow.pause_slideshow' | t }}`,
playSlideshow:  `{{ 'sections.slideshow.play_slideshow' | t }}`,
recipientFormExpanded:  `{{ 'recipient.form.expanded' | t }}`,
recipientFormCollapsed: `{{ 'recipient.form.collapsed' | t }}`,
countrySelectorSearchCount: `{{ 'localization.country_results_count' | t: count: '[count]' }}`,
};

const btn = document.querySelector('.st-scrolltop');
if (btn) {
    const showAfter = 500;

    function update(){
    if (window.scrollY > showAfter) btn.classList.add('is-visible');
    else btn.classList.remove('is-visible');
    }

    btn.addEventListener('click', function(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', update, { passive: true });
    update();
}